export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lingua"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buongiorno"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buon pomeriggio"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buonasera"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buona notte"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Esci"])}
}